import Breadcrumb from '../Component/Breadcrumb'
const Contact = () => {
    return (
        <>
            <Breadcrumb breadtitle="Contact" breadmid="Contact" breadend="Contact" />
            <div className="innerpage">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                           <div className='contact-list'>
                            <div>
                                <p><i class="bi bi-geo-alt-fill"></i> Kukrail Picnic Spot Road, Faridinagar, Lucknow</p>
                            </div>
                            <div>
                                <p><a href="tel:0522-2972291"><i class="bi bi-telephone-outbound-fill"></i> 0522-2972291</a></p>
                            </div>
                            <div>
                                <p><i class="bi bi-telephone-outbound-fill"></i> <a href="tel:9454376364">9454376364, </a>, <a href="tel:9415999947"> 9415999947</a></p>
                            </div>
                            <div>
                                <p> <i class="bi bi-envelope-open-fill"></i> 
                                <a href="mailto: canossaschool@rocketmail.com">canossaschool@rocketmail.com</a>
                                </p>
                            </div>
                           </div>
                            
                        </div>
                        
                        <div className="col-md-6">
                        <div className='iframe-map'><iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3558.1989924498544!2d80.99298847606578!3d26.897179060756738!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39995804c4ff0789%3A0xf62f71b1099e6624!2sCanossa%20School%2C%20Lucknow!5e0!3m2!1sen!2sin!4v1755838852990!5m2!1sen!2sin" width="600" height="250" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe></div>
                        </div>
                    </div>
                </div> 
            </div>
        </>
    )
}
export default Contact